function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var PokerCards = /*#__PURE__*/function () {
  function PokerCards() {
    _classCallCheck(this, PokerCards);
  }
  return _createClass(PokerCards, [{
    key: "returnCardFromDeck",
    value: function returnCardFromDeck(idx) {
      var deck = this.returnDeck();
      var card = deck[idx];
      return card.name.substring(0, card.name.indexOf('.'));
    }
  }, {
    key: "returnDeck",
    value: function returnDeck() {
      var deck = {};
      deck['1'] = {
        name: 'S1.png'
      };
      deck['2'] = {
        name: 'S2.png'
      };
      deck['3'] = {
        name: 'S3.png'
      };
      deck['4'] = {
        name: 'S4.png'
      };
      deck['5'] = {
        name: 'S5.png'
      };
      deck['6'] = {
        name: 'S6.png'
      };
      deck['7'] = {
        name: 'S7.png'
      };
      deck['8'] = {
        name: 'S8.png'
      };
      deck['9'] = {
        name: 'S9.png'
      };
      deck['10'] = {
        name: 'S10.png'
      };
      deck['11'] = {
        name: 'S11.png'
      };
      deck['12'] = {
        name: 'S12.png'
      };
      deck['13'] = {
        name: 'S13.png'
      };
      deck['14'] = {
        name: 'C1.png'
      };
      deck['15'] = {
        name: 'C2.png'
      };
      deck['16'] = {
        name: 'C3.png'
      };
      deck['17'] = {
        name: 'C4.png'
      };
      deck['18'] = {
        name: 'C5.png'
      };
      deck['19'] = {
        name: 'C6.png'
      };
      deck['20'] = {
        name: 'C7.png'
      };
      deck['21'] = {
        name: 'C8.png'
      };
      deck['22'] = {
        name: 'C9.png'
      };
      deck['23'] = {
        name: 'C10.png'
      };
      deck['24'] = {
        name: 'C11.png'
      };
      deck['25'] = {
        name: 'C12.png'
      };
      deck['26'] = {
        name: 'C13.png'
      };
      deck['27'] = {
        name: 'H1.png'
      };
      deck['28'] = {
        name: 'H2.png'
      };
      deck['29'] = {
        name: 'H3.png'
      };
      deck['30'] = {
        name: 'H4.png'
      };
      deck['31'] = {
        name: 'H5.png'
      };
      deck['32'] = {
        name: 'H6.png'
      };
      deck['33'] = {
        name: 'H7.png'
      };
      deck['34'] = {
        name: 'H8.png'
      };
      deck['35'] = {
        name: 'H9.png'
      };
      deck['36'] = {
        name: 'H10.png'
      };
      deck['37'] = {
        name: 'H11.png'
      };
      deck['38'] = {
        name: 'H12.png'
      };
      deck['39'] = {
        name: 'H13.png'
      };
      deck['40'] = {
        name: 'D1.png'
      };
      deck['41'] = {
        name: 'D2.png'
      };
      deck['42'] = {
        name: 'D3.png'
      };
      deck['43'] = {
        name: 'D4.png'
      };
      deck['44'] = {
        name: 'D5.png'
      };
      deck['45'] = {
        name: 'D6.png'
      };
      deck['46'] = {
        name: 'D7.png'
      };
      deck['47'] = {
        name: 'D8.png'
      };
      deck['48'] = {
        name: 'D9.png'
      };
      deck['49'] = {
        name: 'D10.png'
      };
      deck['50'] = {
        name: 'D11.png'
      };
      deck['51'] = {
        name: 'D12.png'
      };
      deck['52'] = {
        name: 'D13.png'
      };
      return deck;
    }

    /* Card to UI conversions */
  }, {
    key: "cardToHuman",
    value: function cardToHuman(card) {
      if (!this.game.deck[0].cards[card]) {
        return '';
      }
      var h = this.game.deck[0].cards[card].name;
      h = h.replace('.png', '');
      h = h.replace('13', 'K');
      h = h.replace('12', 'Q');
      h = h.replace('11', 'J');
      h = h.replace('1', 'A');
      h = h.replace('A0', '10'); //restore ten
      var suit = h[0];
      h = h.substring(1);
      switch (suit) {
        case 'H':
          return h + 'h';
          break;
        case 'D':
          return h + 'd';
          break;
        case 'S':
          return h + 's';
          break;
        case 'C':
          return h + 'c';
          break;
      }
      return h;
    }
  }, {
    key: "toHuman",
    value: function toHuman(hand) {
      var humanHand = ' <span class=\'htmlhand\'>';
      hand.forEach(function (h) {
        h = h.replace('H', '<span style=\'color:red\'><span class=\'suit\'>&hearts;</span>');
        h = h.replace('D', '<span style=\'color:red\'><span class=\'suit\'>&diams;</span>');
        h = h.replace('S', '<span style=\'color:black\'><span class=\'suit\'>&spades;</span>');
        h = h.replace('C', '<span style=\'color:black\'><span class=\'suit\'>&clubs;</span>');
        h = h.replace('13', 'K');
        h = h.replace('12', 'Q');
        h = h.replace('11', 'J');
        h = h.replace('1', 'A');
        h = h.replace('A0', '10');
        h = '<span class=\'htmlCard\'>' + h + '</span></span>';
        humanHand += h;
      });
      humanHand += '</span> ';
      return humanHand;
    }
  }, {
    key: "handToHTML",
    value: function handToHTML(hand, pocket) {
      var _this = this;
      var html = '<div class=\'htmlCards pocket\'>';
      pocket.forEach(function (card) {
        html += "<img class=\"card ".concat(hand.includes(card) ? 'used' : 'not_used', "\" src=\"").concat(_this.card_img_dir, "/").concat(card, ".png\">");
      });
      html += '</div> ';
      html += '<div class=\'htmlCards pool\'>';
      this.game.pool[0].hand.forEach(function (card) {
        card = _this.game.pool[0].cards[card].name.replace('.png', '');
        html += "<img class=\"card ".concat(hand.includes(card) ? 'used' : 'not_used', "\" src=\"").concat(_this.card_img_dir, "/").concat(card, ".png\">");
      });
      html += '</div> ';
      return html;
    }

    /* Functions to analyze hands and compare them*/
  }, {
    key: "pickWinner",
    value: function pickWinner(score1, score2) {
      var hands_differ = false;

      //Check if hands are different
      for (var i = 0; i < score1.cards_to_score.length; i++) {
        if (score1.cards_to_score[i] !== score2.cards_to_score[i]) {
          hands_differ = true;
        }
      }
      if (!hands_differ) {
        return 3; // == tie
      }
      if (score1.hand_description == 'royal flush' && score2.hand_description == 'royal flush') {
        for (var _i = 0; _i < score1.cards_to_score.length; _i++) {
          // first card will be aces, so we only need to compare the first entry
          if (this.returnHigherCard(score1.cards_to_score[_i], score2.cards_to_score[_i]) == score1.cards_to_score[_i]) {
            return 1;
          } else {
            return 2;
          }
        }
      }
      if (score1.hand_description == 'royal flush') {
        return 1;
      }
      if (score2.hand_description == 'royal flush') {
        return 2;
      }
      if (score1.hand_description == 'straight flush' && score2.hand_description == 'straight flush') {
        for (var _i2 = 0; _i2 < score1.cards_to_score.length; _i2++) {
          if (this.returnHigherNumberCard(score1.cards_to_score[_i2], score2.cards_to_score[_i2]) == score1.cards_to_score[_i2]) {
            return 1;
          }
          if (this.returnHigherNumberCard(score1.cards_to_score[_i2], score2.cards_to_score[_i2]) == score2.cards_to_score[_i2]) {
            return 2;
          }
        }
        return 3;
      }
      if (score1.hand_description == 'straight flush') {
        return 1;
      }
      if (score2.hand_description == 'straight flush') {
        return 2;
      }
      if (score1.hand_description == 'four-of-a-kind' && score2.hand_description == 'four-of-a-kind') {
        if (this.returnHigherNumberCard(score1.cards_to_score[0], score2.cards_to_score[0]) == score1.cards_to_score[0]) {
          return 1;
        }
        if (this.returnHigherNumberCard(score1.cards_to_score[0], score2.cards_to_score[0]) == score2.cards_to_score[0]) {
          return 2;
        }
        if (this.returnHigherNumberCard(score1.cards_to_score[4], score2.cards_to_score[4]) == score1.cards_to_score[4]) {
          return 1;
        }
        if (this.returnHigherNumberCard(score1.cards_to_score[4], score2.cards_to_score[4]) == score2.cards_to_score[4]) {
          return 2;
        }
        return 3;
      }
      if (score1.hand_description == 'four-of-a-kind') {
        return 1;
      }
      if (score2.hand_description == 'four-of-a-kind') {
        return 2;
      }
      if (score1.hand_description == 'full house' && score2.hand_description == 'full house') {
        if (this.returnHigherNumberCard(score1.cards_to_score[0], score2.cards_to_score[0]) == score1.cards_to_score[0]) {
          return 1;
        }
        if (this.returnHigherNumberCard(score1.cards_to_score[0], score2.cards_to_score[0]) == score2.cards_to_score[0]) {
          return 2;
        }
        if (this.returnHigherNumberCard(score1.cards_to_score[3], score2.cards_to_score[3]) == score1.cards_to_score[3]) {
          return 1;
        }
        if (this.returnHigherNumberCard(score1.cards_to_score[3], score2.cards_to_score[3]) == score2.cards_to_score[3]) {
          return 2;
        }
        return 3;
      }
      if (score1.hand_description == 'full house') {
        return 1;
      }
      if (score2.hand_description == 'full house') {
        return 2;
      }
      if (score1.hand_description == 'flush' && score2.hand_description == 'flush') {
        for (var _i3 = 0; _i3 < score1.cards_to_score.length; _i3++) {
          if (this.returnHigherCard(score1.cards_to_score[_i3], score2.cards_to_score[_i3]) == score1.cards_to_score[_i3]) {
            return 1;
          }
          if (this.returnHigherCard(score1.cards_to_score[_i3], score2.cards_to_score[_i3]) == score2.cards_to_score[_i3]) {
            return 2;
          }
        }
        return 3;
      }
      if (score1.hand_description == 'flush') {
        return 1;
      }
      if (score2.hand_description == 'flush') {
        return 2;
      }
      if (score1.hand_description == 'straight' && score2.hand_description == 'straight') {
        for (var _i4 = 0; _i4 < score1.cards_to_score.length; _i4++) {
          if (this.returnHigherNumberCard(score1.cards_to_score[_i4], score2.cards_to_score[_i4]) == score1.cards_to_score[_i4]) {
            return 1;
          }
          if (this.returnHigherNumberCard(score1.cards_to_score[_i4], score2.cards_to_score[_i4]) == score2.cards_to_score[_i4]) {
            return 2;
          }
        }
        return 3;
      }
      if (score1.hand_description == 'straight') {
        return 1;
      }
      if (score2.hand_description == 'straight') {
        return 2;
      }
      if (score1.hand_description == 'three-of-a-kind' && score2.hand_description == 'three-of-a-kind') {
        if (this.returnHigherNumberCard(score1.cards_to_score[0], score2.cards_to_score[0]) == score1.cards_to_score[0]) {
          return 1;
        }
        if (this.returnHigherNumberCard(score1.cards_to_score[0], score2.cards_to_score[0]) == score2.cards_to_score[0]) {
          return 2;
        }
        for (var _i5 = 3; _i5 < 5; _i5++) {
          if (this.returnHigherNumberCard(score1.cards_to_score[_i5], score2.cards_to_score[_i5]) == score1.cards_to_score[_i5]) {
            return 1;
          }
          if (this.returnHigherNumberCard(score1.cards_to_score[_i5], score2.cards_to_score[_i5]) == score2.cards_to_score[_i5]) {
            return 2;
          }
        }
        return 3;
      }
      if (score1.hand_description == 'three-of-a-kind') {
        return 1;
      }
      if (score2.hand_description == 'three-of-a-kind') {
        return 2;
      }
      if (score1.hand_description == 'two pair' && score2.hand_description == 'two pair') {
        if (this.returnHigherNumberCard(score1.cards_to_score[0], score2.cards_to_score[0]) == score1.cards_to_score[0]) {
          return 1;
        }
        if (this.returnHigherNumberCard(score1.cards_to_score[0], score2.cards_to_score[0]) == score2.cards_to_score[0]) {
          return 2;
        }
        if (this.returnHigherNumberCard(score1.cards_to_score[2], score2.cards_to_score[2]) == score1.cards_to_score[2]) {
          return 1;
        }
        if (this.returnHigherNumberCard(score1.cards_to_score[2], score2.cards_to_score[2]) == score2.cards_to_score[2]) {
          return 2;
        }
        if (this.returnHigherNumberCard(score1.cards_to_score[4], score2.cards_to_score[4]) == score1.cards_to_score[4]) {
          return 1;
        }
        if (this.returnHigherNumberCard(score1.cards_to_score[4], score2.cards_to_score[4]) == score2.cards_to_score[4]) {
          return 2;
        }
        return 3;
      }
      if (score1.hand_description == 'two pair') {
        return 1;
      }
      if (score2.hand_description == 'two pair') {
        return 2;
      }
      if (score1.hand_description == 'pair' && score2.hand_description == 'pair') {
        if (this.returnHigherNumberCard(score1.cards_to_score[0], score2.cards_to_score[0]) == score1.cards_to_score[0]) {
          return 1;
        }
        if (this.returnHigherNumberCard(score1.cards_to_score[0], score2.cards_to_score[0]) == score2.cards_to_score[0]) {
          return 2;
        }
        if (this.returnHigherNumberCard(score1.cards_to_score[2], score2.cards_to_score[2]) == score1.cards_to_score[2]) {
          return 1;
        }
        if (this.returnHigherNumberCard(score1.cards_to_score[2], score2.cards_to_score[2]) == score2.cards_to_score[2]) {
          return 2;
        }
        if (this.returnHigherNumberCard(score1.cards_to_score[4], score2.cards_to_score[4]) == score1.cards_to_score[4]) {
          return 1;
        }
        if (this.returnHigherNumberCard(score1.cards_to_score[4], score2.cards_to_score[4]) == score2.cards_to_score[4]) {
          return 2;
        }
        return 3;
      }
      if (score1.hand_description == 'pair') {
        return 1;
      }
      if (score2.hand_description == 'pair') {
        return 2;
      }
      if (score1.hand_description == 'highest card' && score2.hand_description == 'highest card') {
        for (var _i6 = 0; _i6 < score1.cards_to_score.length; _i6++) {
          if (this.returnHigherNumberCard(score1.cards_to_score[_i6], score2.cards_to_score[_i6]) == score1.cards_to_score[_i6]) {
            return 1;
          }
          if (this.returnHigherNumberCard(score1.cards_to_score[_i6], score2.cards_to_score[_i6]) == score2.cards_to_score[_i6]) {
            return 2;
          }
        }
        return 3;
      }
      if (score1.hand_description == 'highest card') {
        return 1;
      }
      if (score2.hand_description == 'highest card') {
        return 2;
      }
    }
  }, {
    key: "scoreHand",
    value: function scoreHand(hand) {
      var x = this.convertHand(hand);
      var suite = x.suite;
      var val = x.val;
      var idx = 0;
      var pairs = [];
      var three_of_a_kind = [];
      var four_of_a_kind = [];
      var straights = [];
      var full_house = [];

      //
      // identify pairs
      //
      idx = 1;
      while (idx < 14) {
        var _x = this.isTwo(suite, val, idx);
        if (_x == 0) {
          idx = 14;
        } else {
          pairs.push(_x);
          idx = _x + 1;
        }
      }
      pairs.sort(function (a, b) {
        return a - b;
      });

      //
      // identify triples
      //
      idx = 1;
      while (idx < 14) {
        var _x2 = this.isThree(suite, val, idx);
        if (_x2 == 0) {
          idx = 14;
        } else {
          three_of_a_kind.push(_x2);
          idx = _x2 + 1;
        }
      }
      three_of_a_kind.sort(function (a, b) {
        return a - b;
      });

      //
      // identify quintuples
      //
      idx = 1;
      while (idx < 14) {
        var _x3 = this.isFour(suite, val, idx);
        if (_x3 == 0) {
          idx = 14;
        } else {
          four_of_a_kind.push(_x3);
          idx = _x3 + 1;
        }
      }

      //
      // identify straights
      //
      idx = 1;
      while (idx < 10) {
        var _x4 = this.isStraight(suite, val, idx);
        if (_x4 == 0) {
          idx = 11;
        } else {
          straights.push(_x4);
          idx = _x4 + 1;
        }
      }

      //
      // remove triples and pairs that are four-of-a-kind
      //
      for (var i = 0; i < four_of_a_kind.length; i++) {
        for (var z = 0; z < three_of_a_kind.length; z++) {
          if (three_of_a_kind[z] === four_of_a_kind[i]) {
            three_of_a_kind.splice(z, 1);
          }
        }
        for (var z = 0; z < pairs.length; z++) {
          if (pairs[z] === four_of_a_kind[i]) {
            pairs.splice(z, 1);
          }
        }
      }

      //
      // remove pairs that are also threes
      //
      for (var _i7 = 0; _i7 < three_of_a_kind.length; _i7++) {
        for (var z = 0; z < pairs.length; z++) {
          if (pairs[z] === three_of_a_kind[_i7]) {
            pairs.splice(z, 1);
          }
        }
      }

      //
      // now ready to identify highest hand
      //
      // royal flush
      // straight flush
      // four-of-a-kind    x
      // full-house
      // flush
      // straight      x
      // three-of-a-kind    x
      // two-pair
      // pair        x
      // high card
      //
      var cards_to_score = [];
      var hand_description = '';
      var highest_card = [];

      //
      // ROYAL FLUSH
      //
      if (straights.includes(10)) {
        if (this.isFlush(suite, val) != '') {
          var _x5 = this.isFlush(suite, val);
          if (this.isCardSuite(suite, val, 1, _x5) == 1 && this.isCardSuite(suite, val, 13, _x5) == 1 && this.isCardSuite(suite, val, 12, _x5) == 1 && this.isCardSuite(suite, val, 11, _x5) == 1 && this.isCardSuite(suite, val, 10, _x5) == 1) {
            cards_to_score.push('1' + _x5);
            cards_to_score.push('13' + _x5);
            cards_to_score.push('12' + _x5);
            cards_to_score.push('11' + _x5);
            cards_to_score.push('10' + _x5);
            hand_description = 'royal flush';
            return {
              cards_to_score: this.sortByValue(cards_to_score),
              hand_description: hand_description
            };
          }
        }
      }

      //
      // STRAIGHT FLUSH
      //
      if (straights.length > 0) {
        if (this.isFlush(suite, val) != '') {
          var _x6 = this.isFlush(suite, val);
          for (var _i8 = straights.length - 1; _i8 >= 0; _i8--) {
            if (this.isCardSuite(suite, val, straights[_i8] + 4, _x6) == 1 && this.isCardSuite(suite, val, straights[_i8] + 3, _x6) == 1 && this.isCardSuite(suite, val, straights[_i8] + 2, _x6) == 1 && this.isCardSuite(suite, val, straights[_i8] + 1, _x6) == 1 && this.isCardSuite(suite, val, straights[_i8], _x6) == 1) {
              cards_to_score.push(straights[_i8] + 4 + _x6);
              cards_to_score.push(straights[_i8] + 3 + _x6);
              cards_to_score.push(straights[_i8] + 2 + _x6);
              cards_to_score.push(straights[_i8] + 1 + _x6);
              cards_to_score.push(straights[_i8] + _x6);
              hand_description = 'straight flush';
              return {
                cards_to_score: this.sortByValue(cards_to_score),
                hand_description: hand_description
              };
            }
          }
        }
      }

      //
      // FOUR OF A KIND
      //
      if (four_of_a_kind.length > 0) {
        if (four_of_a_kind.includes(1)) {
          cards_to_score = ['C1', 'D1', 'H1', 'S1'];
          highest_card = this.returnHighestCard(suite, val, cards_to_score);
          cards_to_score.push(highest_card);
          hand_description = 'four-of-a-kind';
          return {
            cards_to_score: cards_to_score,
            hand_description: hand_description
          };
        }
        cards_to_score = ['C' + four_of_a_kind[four_of_a_kind.length - 1], 'D' + four_of_a_kind[four_of_a_kind.length - 1], 'H' + four_of_a_kind[four_of_a_kind.length - 1], 'S' + four_of_a_kind[four_of_a_kind.length - 1]];
        highest_card = this.returnHighestCard(suite, val, cards_to_score);
        hand_description = 'four-of-a-kind';
        cards_to_score.push(highest_card);
        return {
          cards_to_score: cards_to_score,
          hand_description: hand_description
        };
      }

      //
      // FULL HOUSE
      //
      if (three_of_a_kind.length == 2) {
        if (three_of_a_kind[0] > three_of_a_kind[1]) {
          pairs.push(three_of_a_kind.pop());
        } else {
          pairs.push(three_of_a_kind.shift());
        }
      }
      if (three_of_a_kind.length > 0 && pairs.length > 0) {
        var highest_suite = 'C';
        for (var _i9 = 0; _i9 < val.length; _i9++) {
          if (val[_i9] == three_of_a_kind[three_of_a_kind.length - 1]) {
            if (this.isHigherSuite(suite[_i9], highest_suite)) {
              highest_suite = suite[_i9];
            }
            cards_to_score.push(suite[_i9] + val[_i9]);
          }
        }
        highest_card = highest_suite + three_of_a_kind[three_of_a_kind.length - 1];
        for (var _i0 = 0; _i0 < val.length; _i0++) {
          if (val[_i0] == pairs[pairs.length - 1]) {
            cards_to_score.push(suite[_i0] + val[_i0]);
          }
          if (cards_to_score.length > 5) {
            cards_to_score.pop();
          }
        }
        hand_description = 'full house';
        return {
          cards_to_score: cards_to_score,
          hand_description: hand_description,
          highest_card: highest_card
        };
      }

      //
      // FLUSH
      //
      if (this.isFlush(suite, val) != '') {
        var _x7 = this.isFlush(suite, val);
        var y = [];
        var has_ace = false;
        for (var _i1 = 0; _i1 < val.length; _i1++) {
          if (suite[_i1] == _x7) {
            y.push(val[_i1]);
          }
        }

        // y now contains only in-suite vals
        y.sort(function (a, b) {
          return a - b;
        });
        // aces high, shift manually if needed
        if (y[0] === 1) {
          y.push(1);
          y.splice(0, 1);
        }
        y.splice(0, y.length - 5);
        for (var _i10 = y.length - 1; _i10 >= 0; _i10--) {
          cards_to_score.push(_x7 + y[_i10]);
        }
        hand_description = 'flush';
        return {
          cards_to_score: this.sortByValue(cards_to_score),
          hand_description: hand_description
        };
      }

      //
      // STRAIGHT
      //
      if (this.isStraight(suite, val) > 0) {
        var _x8 = this.isStraight(suite, val);
        hand_description = 'straight';

        //ace hight straight
        if (_x8 == 10) {
          cards_to_score.push(this.returnHighestSuiteCard(suite, val, 1));
          cards_to_score.push(this.returnHighestSuiteCard(suite, val, 13));
          cards_to_score.push(this.returnHighestSuiteCard(suite, val, 12));
          cards_to_score.push(this.returnHighestSuiteCard(suite, val, 11));
          cards_to_score.push(this.returnHighestSuiteCard(suite, val, 10));
          return {
            cards_to_score: cards_to_score,
            hand_description: hand_description
          };
        }
        //ace low straight
        if (_x8 == 1) {
          cards_to_score.push(this.returnHighestSuiteCard(suite, val, 5));
          cards_to_score.push(this.returnHighestSuiteCard(suite, val, 4));
          cards_to_score.push(this.returnHighestSuiteCard(suite, val, 3));
          cards_to_score.push(this.returnHighestSuiteCard(suite, val, 2));
          cards_to_score.push(this.returnHighestSuiteCard(suite, val, 1));
          return {
            cards_to_score: cards_to_score,
            hand_description: hand_description
          };
        }
        for (var _i11 = 4; _i11 >= 0; _i11--) {
          cards_to_score.push(this.returnHighestSuiteCard(suite, val, _x8 + _i11));
        }
        return {
          cards_to_score: this.sortByValue(cards_to_score),
          hand_description: hand_description
        };
      }

      //
      // THREE OF A KIND
      //
      if (three_of_a_kind.length > 0) {
        var _x9 = three_of_a_kind[three_of_a_kind.length - 1];
        var _y = [];
        var cards_remaining = val.length;
        for (var _i12 = 0; _i12 < cards_remaining; _i12++) {
          if (val[_i12] == _x9) {
            _y.push(suite[_i12] + val[_i12]);
            val.splice(_i12, 1);
            suite.splice(_i12, 1);
            cards_remaining--;
            _i12--;
          }
        }
        for (var _i13 = 0; _i13 < _y.length; _i13++) {
          cards_to_score.push(_y[_i13]);
        }
        var _remaining = this.returnHighestCard(suite, val);
        var _remaining2 = this.returnHighestCard(suite, val, [_remaining]);
        var remaining_cards = this.sortByValue([_remaining, _remaining2]);
        for (var _i14 = 0; _i14 < remaining_cards.length; _i14++) {
          cards_to_score.push(remaining_cards[_i14]);
        }
        hand_description = 'three-of-a-kind';
        return {
          cards_to_score: cards_to_score,
          hand_description: hand_description
        };
      }

      //
      // TWO PAIR
      //
      if (pairs.length > 1) {
        pairs.sort(function (a, b) {
          return a - b;
        });

        // deal with three pairs.
        if (pairs.length == 3) {
          if (pairs[0] == 1) {
            pairs.push(pairs.shift());
          }
          pairs.shift();
        }
        var m = pairs[pairs.length - 1];
        var n = pairs[pairs.length - 2];
        if (m > n) {
          highest_card = m;
        } else {
          highest_card = n;
        }
        if (n == 1) {
          highest_card = n;
        }
        var _cards_remaining = val.length;
        for (var _i15 = 0; _i15 < _cards_remaining; _i15++) {
          if (val[_i15] == highest_card) {
            cards_to_score.push(suite[_i15] + val[_i15]);
            val.splice(_i15, 1);
            suite.splice(_i15, 1);
            _cards_remaining--;
            _i15--;
          }
        }
        _cards_remaining = val.length;
        for (var _i16 = 0; _i16 < _cards_remaining; _i16++) {
          if (val[_i16] == m || val[_i16] == n) {
            cards_to_score.push(suite[_i16] + val[_i16]);
            val.splice(_i16, 1);
            suite.splice(_i16, 1);
            _cards_remaining--;
            _i16--;
          }
        }
        var _remaining3 = this.returnHighestCard(suite, val, cards_to_score);
        cards_to_score.push(_remaining3);
        hand_description = 'two pair';
        return {
          cards_to_score: cards_to_score,
          hand_description: hand_description
        };
      }

      //
      // A PAIR
      //
      if (pairs.length > 0) {
        var _x0 = pairs[pairs.length - 1];
        var _y2 = [];
        var _cards_remaining2 = val.length;
        for (var _i17 = 0; _i17 < _cards_remaining2; _i17++) {
          if (val[_i17] == _x0) {
            _y2.push(suite[_i17] + val[_i17]);
            val.splice(_i17, 1);
            suite.splice(_i17, 1);
            _cards_remaining2--;
            _i17--;
          }
        }
        var _remaining4 = this.returnHighestCard(suite, val);
        var _remaining5 = this.returnHighestCard(suite, val, [_remaining4]);
        var _remaining6 = this.returnHighestCard(suite, val, [_remaining4, _remaining5]);
        var cards_remaining2 = this.sortByValue([_remaining4, _remaining5, _remaining6]);
        //let cards_remaining2 = [remaining1, remaining2, remaining3];
        cards_to_score.push(_y2[0]);
        cards_to_score.push(_y2[1]);
        for (var _i18 = 0; _i18 < cards_remaining2.length; _i18++) {
          cards_to_score.push(cards_remaining2[_i18]);
        }
        hand_description = 'pair';
        return {
          cards_to_score: cards_to_score,
          hand_description: hand_description
        };
      }

      //
      // HIGHEST CARD
      //
      var remaining1 = this.returnHighestCard(suite, val);
      var remaining2 = this.returnHighestCard(suite, val, [remaining1]);
      var remaining3 = this.returnHighestCard(suite, val, [remaining1, remaining2]);
      var remaining4 = this.returnHighestCard(suite, val, [remaining1, remaining2, remaining3]);
      var remaining5 = this.returnHighestCard(suite, val, [remaining1, remaining2, remaining3, remaining4]);
      cards_to_score.push(remaining1);
      cards_to_score.push(remaining2);
      cards_to_score.push(remaining3);
      cards_to_score.push(remaining4);
      cards_to_score.push(remaining5);
      hand_description = 'highest card';
      highest_card = remaining1;
      return {
        cards_to_score: this.sortByValue(cards_to_score),
        hand_description: hand_description
      };
    }
  }, {
    key: "convertHand",
    value: function convertHand(hand) {
      var x = {};
      x.suite = [];
      x.val = [];
      for (var i = 0; i < hand.length; i++) {
        x.suite.push(hand[i][0]);
        x.val.push(parseInt(hand[i].substring(1)));
      }
      return x;
    }
  }, {
    key: "sortByValue",
    value: function sortByValue(cards) {
      //let x = this.convertHand(cards);
      var y = [];
      var idx = 0;
      y.push(cards[0]);
      for (var i = 1; i < cards.length; i++) {
        idx = 0;
        for (var j = 0; j < y.length; j++) {
          if (this.returnHigherCard(cards[i], y[j]) == y[j]) {
            idx = j + 1;
          }
        }
        y.splice(idx, 0, cards[i]);
      }
      return y;
    }
  }, {
    key: "returnHigherCard",
    value: function returnHigherCard(card1, card2) {
      var card1_suite = card1[0];
      var card1_val = parseInt(card1.substring(1));
      var card2_suite = card2[0];
      var card2_val = parseInt(card2.substring(1));
      if (card1_val == 1) {
        card1_val = 14;
      }
      if (card2_val == 1) {
        card2_val = 14;
      }
      if (card1_val > card2_val) {
        return card1;
      }
      if (card2_val > card1_val) {
        return card2;
      }
      if (card2_val == card1_val) {
        if (card1_suite == card2_suite) {
          return 0;
        }
        if (this.isHigherSuite(card1_suite, card2_suite)) {
          return card1;
        } else {
          return card2;
        }
      }
    }
  }, {
    key: "returnHigherNumberCard",
    value: function returnHigherNumberCard(card1, card2) {
      var card1_val = parseInt(card1.substring(1));
      var card2_val = parseInt(card2.substring(1));
      if (card1_val == 1) {
        card1_val = 14;
      }
      if (card2_val == 1) {
        card2_val = 14;
      }
      if (card1_val > card2_val) {
        return card1;
      }
      if (card2_val > card1_val) {
        return card2;
      }
      if (card2_val == card1_val) {
        return 0;
      }
    }
  }, {
    key: "isHigherSuite",
    value: function isHigherSuite(currentv, newv) {
      if (currentv === 'S') {
        return 1;
      }
      if (newv == 'S') {
        return 0;
      }
      if (currentv === 'H') {
        return 1;
      }
      if (newv == 'H') {
        return 0;
      }
      if (currentv === 'D') {
        return 1;
      }
      if (newv == 'D') {
        return 0;
      }
      if (currentv === 'C') {
        return 1;
      }
      if (newv == 'C') {
        return 0;
      }
    }
  }, {
    key: "returnHighestSuiteCard",
    value: function returnHighestSuiteCard(suite, val, x) {
      var suite_to_return = 'C';
      var card_to_return = '';
      for (var i = 0; i < val.length; i++) {
        if (val[i] == x) {
          if (card_to_return != '') {
            if (this.isHigherSuite(suite_to_return, suite[i])) {
              suite_to_return = suite[i];
              card_to_return = suite[i] + val[i];
            }
          } else {
            suite_to_return = suite[i];
            card_to_return = suite[i] + val[i];
          }
        }
      }
      return card_to_return;
    }
  }, {
    key: "returnHighestCard",
    value: function returnHighestCard(suite, val) {
      var noval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var less_than = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 14;
      var highest_card = 0;
      var highest_suite = 'C';
      var highest_idx = 0;
      for (var i = 0; i < val.length; i++) {
        if (noval.includes(suite[i] + val[i])) {
          //if the case id not in the exclude list
        } else {
          if (val[i] == 1) {
            //if the candidate is an ace
            if (highest_card == 14) {
              //and the encumbent is an ace
              if (this.isHigherSuite(suite[i], highest_suite)) {
                //if the candidate is a higher suite
                //the candidate wins
                highest_suite = suite[i];
              }
            } else {
              highest_card = 14; // and if there was no encumbent - the candidate is the winner.
              highest_suite = suite[i];
            }
          }
          if (val[i] == highest_card) {
            //if the candiates is as high as the encumbent
            if (this.isHigherSuite(suite[i], highest_suite)) {
              //if the candidate has a higher suite
              highest_suite = suite[i];
            }
          }
          if (val[i] > highest_card) {
            // if the candidate is just higher
            highest_card = val[i]; // the candidate wins
            highest_suite = suite[i]; // the candiate wins
          }
        }
      }
      if (highest_card == 14) {
        highest_card = 1;
      }
      return highest_suite + highest_card;
    }
  }, {
    key: "isFlush",
    value: function isFlush(suite, val) {
      var total_clubs = 0;
      var total_spades = 0;
      var total_hearts = 0;
      var total_diamonds = 0;
      for (var i = 0; i < suite.length; i++) {
        if (suite[i] == 'C') {
          total_clubs++;
        }
        if (suite[i] == 'D') {
          total_diamonds++;
        }
        if (suite[i] == 'H') {
          total_hearts++;
        }
        if (suite[i] == 'S') {
          total_spades++;
        }
      }
      if (total_clubs >= 5) {
        return 'C';
      }
      if (total_spades >= 5) {
        return 'S';
      }
      if (total_hearts >= 5) {
        return 'H';
      }
      if (total_diamonds >= 5) {
        return 'D';
      }
      return '';
    }
  }, {
    key: "isFour",
    value: function isFour(suite, val) {
      var low = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      for (var i = low - 1; i < 13; i++) {
        var total = 0;
        for (var z = 0; z < val.length; z++) {
          if (val[z] == i + 1) {
            total++;
            if (total == 4) {
              return i + 1;
            }
          }
        }
      }
      return 0;
    }
  }, {
    key: "isThree",
    value: function isThree(suite, val) {
      var low = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      for (var i = low - 1; i < 13; i++) {
        var total = 0;
        for (var z = 0; z < val.length; z++) {
          if (val[z] == i + 1) {
            total++;
            if (total == 3) {
              return i + 1;
            }
          }
        }
      }
      return 0;
    }
  }, {
    key: "isTwo",
    value: function isTwo(suite, val) {
      var low = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      for (var i = low - 1; i < 13; i++) {
        var total = 0;
        for (var z = 0; z < val.length; z++) {
          if (val[z] == i + 1) {
            total++;
            if (total == 2) {
              return i + 1;
            }
          }
        }
      }
      return 0;
    }
  }, {
    key: "isStraight",
    value: function isStraight(suite, val) {
      var low = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var rv = 0;
      for (var i = low - 1; i < 10; i++) {
        //
        // catch royal straight
        //
        if (i == 9) {
          if (val.includes(13) && val.includes(12) && val.includes(11) && val.includes(10) && val.includes(1)) {
            rv = 10;
          }
        }
        if (val.includes(i + 1) && val.includes(i + 2) && val.includes(i + 3) && val.includes(i + 4) && val.includes(i + 5)) {
          rv = i + 1;
        }
      }
      return rv;
    }
  }, {
    key: "isCardSuite",
    value: function isCardSuite(suite, val, card, s) {
      for (var i = 0; i < val.length; i++) {
        if (val[i] == card) {
          if (suite[i] == s) {
            return 1;
          }
        }
      }
      return 0;
    }
  }, {
    key: "preloadImages",
    value: function preloadImages() {
      var allImages = ['/poker/img/cards/C1.png', '/poker/img/cards/C2.png', '/poker/img/cards/C3.png', '/poker/img/cards/C4.png', '/poker/img/cards/C5.png', '/poker/img/cards/C6.png', '/poker/img/cards/C7.png', '/poker/img/cards/C8.png', '/poker/img/cards/C9.png', '/poker/img/cards/C10.png', '/poker/img/cards/C11.png', '/poker/img/cards/C12.png', '/poker/img/cards/C13.png', '/poker/img/cards/S1.png', '/poker/img/cards/S2.png', '/poker/img/cards/S3.png', '/poker/img/cards/S4.png', '/poker/img/cards/S5.png', '/poker/img/cards/S6.png', '/poker/img/cards/S7.png', '/poker/img/cards/S8.png', '/poker/img/cards/S9.png', '/poker/img/cards/S10.png', '/poker/img/cards/S11.png', '/poker/img/cards/S12.png', '/poker/img/cards/S13.png', '/poker/img/cards/D1.png', '/poker/img/cards/D2.png', '/poker/img/cards/D3.png', '/poker/img/cards/D4.png', '/poker/img/cards/D5.png', '/poker/img/cards/D6.png', '/poker/img/cards/D7.png', '/poker/img/cards/D8.png', '/poker/img/cards/D9.png', '/poker/img/cards/D10.png', '/poker/img/cards/D11.png', '/poker/img/cards/D12.png', '/poker/img/cards/D13.png', '/poker/img/cards/H1.png', '/poker/img/cards/H2.png', '/poker/img/cards/H3.png', '/poker/img/cards/H4.png', '/poker/img/cards/H5.png', '/poker/img/cards/H6.png', '/poker/img/cards/H7.png', '/poker/img/cards/H8.png', '/poker/img/cards/H9.png', '/poker/img/cards/H10.png', '/poker/img/cards/H11.png', '/poker/img/cards/H12.png', '/poker/img/cards/H13.png'];
      this.preloadImageArray(allImages, 0);
    }
  }, {
    key: "preloadImageArray",
    value: function preloadImageArray() {
      var _this2 = this;
      var imageArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var idx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var pre_images = [imageArray.length];
      if (imageArray && imageArray.length > idx) {
        pre_images[idx] = new Image();
        pre_images[idx].onload = function () {
          _this2.preloadImageArray(imageArray, idx + 1);
        };
        pre_images[idx].src = imageArray[idx];
      }
    }
  }]);
}();
module.exports = PokerCards;